import { useState } from "react";
import { useNavigate } from "react-router";
import { HeroSection } from "@/components/landing/HeroSection";
import { useLandingContent } from "@/hooks/useLandingContent";
import { FloatingCompareCTA } from "@/components/landing/FloatingCompareCTA";
import { useWorkFor } from "@/hooks/useWorkFor";
import { workForDisplay } from "@penn/web-common";

import partnerLogos from "@/assets/images/brand-logo/partner-logos.svg";

type Modal =
  | "none"
  | "support"
  | "assumptions"
  | "account"
  | "existing-apps"
  | "new-app"
  | "configure"
  | "tasks";

export const LandingPage = () => {
  const navigate = useNavigate();
  const { data: landingContent, isLoading } = useLandingContent();
  const actingForOther = !!workForDisplay(useWorkFor());
  const [selected] = useState<string[]>([]);
  const [, setModal] = useState<Modal>("none");
  const [, setConfigureSolution] = useState<{
    name: string;
    sub?: string;
  } | null>(null);

  const open = (m: Modal) => setModal(m);

  const handleConfigure = (solutionName: string) => {
    setConfigureSolution({ name: solutionName });
    open("configure");
  };

  return (
    <div className={`min-h-dvh flex flex-col bg-penn-900 ${actingForOther ? "pt-44" : "pt-35"}`}>
      {/* Brand-logo strip — single white-on-transparent SVG lockup (PEM ·
          PEMSERTER · PROFIL · Haeger by PEM · MDS · Sherex), so it sits
          directly on the navy with no per-logo pill. */}
      <div className="shrink-0 flex items-center justify-center sm:justify-end bg-penn-900 px-3 sm:px-6 lg:px-8 py-4">
        <img
          src={partnerLogos}
          alt="PEM, PEMSERTER, PROFIL, Haeger by PEM, MDS, Sherex"
          className="h-7 sm:h-8 w-auto max-w-full object-contain"
        />
      </div>

      <HeroSection apiCategories={landingContent?.categories} isLoading={isLoading} />

      {/* Claim bar */}
      <div className="shrink-0 bg-penn-900 px-4 sm:px-6 lg:px-8 py-6 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <p className="text-h2 text-white font-normal">
          A <span className="font-semibold">solution</span> for every{" "}
          <span className="font-semibold">installation.</span>
        </p>
        <p className="text-body-lg text-penn-100">
          Find the right system for your application.
        </p>
        <button
          onClick={() => navigate("/installation-system")}
          className="self-start md:self-auto shrink-0 rounded-full bg-penn-500 hover:bg-penn-400 text-white text-button px-7 py-3 transition-colors cursor-pointer"
        >
          Configure now
        </button>
      </div>

      <FloatingCompareCTA
        count={selected.length}
        onCompare={() => {
          const first = selected[0];
          if (first) handleConfigure(first);
        }}
      />
    </div>
  );
};
